import { CircularProgress } from '@mui/material';
import { useState } from 'react';
import { FileUploader } from 'components/FileUploader';
import { bulkCreateColours } from 'apiCalls/apiCalls';
import { getColours } from 'apiCalls/apiCalls';
import { ErrorMessage, SuccessMessage } from 'components/CommonComponents';
import { Modal } from 'components/Modal';
import { TextButton } from 'components/Buttons';
import { Grid, GridItem } from 'components/Grid';
import { PAD_MEDIUM_NUMBER } from 'providers/designSystem';

const BulkImportModal = ({ isOpen, setIsOpen, setColours }) => {
    const [error, setError] = useState(false);
    const [pending, setPending] = useState(false);
    const [success, setSuccess] = useState(false);
    const [showUploader, setShowUploader] = useState(true);

    const handleClose = async () => {
        try {
            const colours = await getColours();
            setColours({ loading: false, result: colours });
            setIsOpen(false);
        } catch (error) {
            setColours({ loading: false, error: { message: 'Network Error' } });
            setIsOpen(false);
        }
    };

    const handleUpload = async data => {
        try {
            setPending(true);
            setShowUploader(false);
            await bulkCreateColours(data);
            setSuccess(true);
            setPending(false);
        } catch (error) {
            setError(true);
            setPending(false);
        }
    };
    return (
        <Modal open={isOpen} onClose={handleClose} width="50vw" height="50vh" title="Bulk Import Colours">
            <Grid numberOfColumns={1} gap={PAD_MEDIUM_NUMBER}>
                {showUploader && (
                    <FileUploader handleUpload={data => handleUpload(data)} accept="text/plain text/html" />
                )}
                {pending && (
                    <GridItem alignSelf="center" justifySelf="center">
                        <CircularProgress />
                    </GridItem>
                )}
                {success && <SuccessMessage message="Import successful!" />}
                {error && <ErrorMessage message="Something went wrong in importing colours. Please try again later" />}
            </Grid>
        </Modal>
    );
};

export const BulkImport = ({ setColours }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openBulkImportModal = () => {
        setIsOpen(true);
    };
    return (
        <>
            <TextButton onClick={openBulkImportModal}>Bulk Import</TextButton>
            {isOpen && <BulkImportModal isOpen={isOpen} setIsOpen={setIsOpen} setColours={setColours} />}
        </>
    );
};
